import { useState, useEffect } from 'react';

/**
 * Custom hook to detect mobile screens (< 768px)
 * @param {number} breakpoint - Width threshold for mobile detection (default: 768px)
 * @returns {boolean} - True if screen width is below breakpoint
 */
export function useMobileDetection(breakpoint = 768) {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < breakpoint);
        };
        
        checkMobile();
        window.addEventListener('resize', checkMobile);
        
        return () => window.removeEventListener('resize', checkMobile);
    }, [breakpoint]);

    return isMobile;
}
